import { ReactElement } from 'react';
import { Tab, Tabs } from '@mui/material';

export type TabModel<T> = {
  label: string;
  value: T;
  display?: boolean;
};

export interface AppTabsProps<T> {
  tabs: TabModel<T>[];
  activeTab: T;
  onTabChange: (tabValue: T) => void;
  'data-testid'?: string;
}

export function AppTabs<T>({ tabs, activeTab, onTabChange, 'data-testid': testId }: AppTabsProps<T>): ReactElement {
  return (
    <Tabs value={activeTab} onChange={(e, value) => onTabChange(value)} variant="scrollable" scrollButtons="auto" data-testid={testId}>
      {tabs.map(({ label, value, display }) => (
        <Tab key={label} label={label} value={value} sx={{ display: !display ? 'none' : undefined }} />
      ))}
    </Tabs>
  );
}
